var map = {
	"./blogs/panels.json": 86142,
	"./contactforms/panels.json": 66130,
	"./countersitestats/panels.json": 50225,
	"./domains/panels.json": 10866,
	"./emailhosting/panels.json": 5097,
	"./guestbooks/panels.json": 20381,
	"./home/panels.json": 66198,
	"./mailinglists/panels.json": 17801,
	"./messageforums/panels.json": 91806,
	"./onlinecalendars/panels.json": 3835,
	"./onlinestore/panels.json": 55841,
	"./passwordprotect/panels.json": 68901,
	"./photoalbums/panels.json": 73393,
	"./sitebuilder/panels.json": 20951,
	"./sitebuilder/templates/panels.json": 82971,
	"./sslcertificates/panels.json": 60351,
	"./webhosting/panels.json": 78475,
	"./webpolls/panels.json": 28659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52794;